import {faX} from '@fortawesome/pro-duotone-svg-icons';
import {faTriangleExclamation} from '@fortawesome/pro-solid-svg-icons';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useEffect, useRef, useState} from 'react';
import styles from './style.module.scss';
import ProfileApi from '@/api/account/customer/profile-api';
import moment from 'moment';
import {getStatusSaUrl} from '@/api/gsc/utils';
import {useRouter} from 'next/router';


const pagesData = {
  'Backlinks': ['/backlink-researcher', '/backlink-analyzer', '/backlink-gap-analysis', '/backlink-profile-analysis'],
  'Content': ['/content/'],
  'GSC Performance': ['/gsc/'],
  'Keyword Explorer / Site Explorer / Local SEO': ['/research/', '/site-explorer/', '/local-search-results'],
  'OTTO / Site Audit / GBP': ['/otto-page', '/site-audit/', '/gbp-galactic/'],
  'Bulk URL Analyzer': ['/bulk-url-analyzer'],
  'OTTO PPC': ['/otto-ppc/'],
  'Schema Creator': ['/schema'],
  'Report Builder': ['/report-builder/'],
  'Authority Building': ['/outreach/'],
  'App Ecosystem': ['/app-ecosystem'],
  'Agency Whitelabel': ['/agency-settings'],
  'Order Builder': ['/order-builder'],
};


export const ServiceHealthAlert = () => {
  const [outages, setOutages] = useState(null);
  const timer = useRef(null);
  const profileApi = new ProfileApi();

  const [data, setData] = useState(null);
  const router = useRouter();


  const getOutage = async ()=>{
    try {
      const result = await profileApi.getOutage();
      if (!localStorage.getItem('outageCloseTime')) {
        setOutages(result?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onClose = ()=>{
    localStorage.setItem('outageCloseTime', moment().format());
    clearInterval(timer.current);
    timer.current = null;
    setOutages(null);
    checkOutageTime();
  };

  const checkOutageTime = ()=>{
    let interval = null;

    interval = setInterval(()=>{
      const time = moment(localStorage.getItem('outageCloseTime'));
      const diff = moment().diff(time);
      if (diff > 1000 * 60 * 5) {
        localStorage.removeItem('outageCloseTime');
        clearInterval(interval);
        getOutage();
        startOutageInterval();
      }
    }, 1000);
  };

  const startOutageInterval = ()=> {
    clearInterval(timer.current);
    timer.current = setInterval(getOutage, 1000 * 60 * 5);
  };

  useEffect(()=>{
    const time = moment(localStorage.getItem('outageCloseTime'));
    const diff = moment().diff(time);
    if (!localStorage.getItem('outageCloseTime') || (diff > 1000 * 60 * 5)) {
      getOutage();
      startOutageInterval();
    } else {
      checkOutageTime();
    }
  }, []);

  const checkIfGeneralOutage = () => {
    const generalComponent = outages?.components?.find(item => item.name.includes('General'));
    if (['degraded', 'outage'].includes(generalComponent?.status)) {
      return generalComponent;
    }
    return null;
  };

  const setOutageData = () => {
    const generalOutage = checkIfGeneralOutage();
    const currentComponent = Object.keys(pagesData).find(key => pagesData[key].some(item => router.pathname.includes(item)));
    const componentOutaged = outages?.components?.find(item => item?.name?.includes(currentComponent));
    ['degraded', 'outage'].includes(componentOutaged?.status) ? setData(componentOutaged) : setData(generalOutage);
  };

  useEffect(()=>{
    setOutageData();
  }, [router.pathname, outages]);

  return data ? (
    <div className={styles.serviceHealthWrapper} style={{backgroundColor: data?.status === 'degraded' ? '#e0a800' : '#dc3545'}}>
      <div/>
      <div className={styles.main}>
        <FontAwesomeIcon className={styles.xicon} color='#fff' icon={faTriangleExclamation}/>
        <div>
          <h1 className={styles.heading}>{data?.reason === 'internal' ? 'We are currently experiencing an outage with this service.' : 'We are currently experiencing an outage with one or more third-party providers.'}</h1>
          <p className={styles.subHeading}>For updates and details, please visit our <a href={`${getStatusSaUrl()}/`} rel='noreferrer' target='_blank'>status page</a>.</p>
        </div>
      </div>
      <FontAwesomeIcon onClick={onClose} icon={faX} width={12} className={styles.icon} color='#fff' height={12}/>
    </div>
  ) : null;
};
